import { Component } from '@angular/core';
import { ProjectDetailsBaseComponent } from './../common-theme/index';

@Component({
  selector: 'app-project-details',
  templateUrl: './../houses/house-details.component.html',
  styleUrls: ['./../houses/house-details.component.scss']
})

export class ProjectDetailsComponent extends ProjectDetailsBaseComponent { }



// WEBPACK FOOTER //
// ./src/app/portfolio/project-details.component.ts